import { cn } from '../../lib/cn';
import type { PurchaseOrderRow } from '../../supplychain/framework';

type Props = { orders?: PurchaseOrderRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'approved': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'pending_approval': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    case 'in_transit': return 'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function ProcurementPanel({ orders = [] }: Props) {
  return (
    <div className="space-y-2">
      {orders.map((o) => (
        <div key={o.po} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{o.po}</p>
            <p className="text-xs text-slate-500">{o.supplier} · {o.items.toLocaleString()} units · {o.value}</p>
          </div>
          <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(o.status))}>
            {o.status.replace('_', ' ')}
          </span>
        </div>
      ))}
    </div>
  );
}
